// extracted by css-extract-rspack-plugin
export default {"withoutLegacyHeader":"cIfd8weEZ4QVAgBt"};